export enum MessageMediaPlacementEnum {
  START = 'start',
  TOP = 'top',
}